import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';

import icons from '../../components/IconsList';

const styles = css`
  padding: 60px 0;
  @media(min-width: 992px) {
    padding: 110px 0;
  }
  .AreasSection_list {
    margin: 0;
    li {
      width: 100%;
      height: 452px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      @media(min-width: 992px) {
        width: calc(50% - 2px);
        height: 607px;
      }
      &:nth-child(even) {
        margin: 3px 0 0;
        @media(min-width: 992px) {
          margin: 0 0 0 3px;
        }
      }
    }
  }
  .AreasSection_item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    transition: all .3s ease-out;
    &:hover {
      background-color: rgba(0, 0, 0, 0.55);
    }
  }
  .AreasSection_title {
    font-weight: 300;
    font-size: 36px;
    color: #FFFFFF;
    letter-spacing: -0.13px;
    text-align: center;
    margin: 0;
    @media(min-width: 992px) {
      font-size: 58px;
      letter-spacing: -0.21px;
    }
  }
  .AreasSection_subtitle {
    font-weight: 900;
    font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 1.95px;
    text-align: center;
    text-transform: uppercase;
    @media(min-width: 992px) {
      font-size: 17px;
      letter-spacing: 2.55px;
    }
  }
  .AreasSection_btn {
    width: 55px;
    height: 55px;
    background-color: rgba(214, 155, 41, 0.85);
    border-radius: 50%;
    position: relative;
    transition: all .3s ease-out;
    @media(min-width: 992px) {
      width: 78px;
      height: 78px;
    }
    &:hover {
      width: 70px;
      height: 70px;
      @media(min-width: 992px) {
        width: 95px;
        height: 95px;
      }
    }
    &::after {
      content: '';
      background-image: url(${icons.arrowRightWhite});
      background-size: 26px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center;
      @media(min-width: 992px) {
        background-size: 38px 15px;
      }
    }
  }
`;

function AreasSection({ areas }) {
  return (
    <div className={styles}>
      <div className="container">
        <ul className="list-unstyled d-lg-flex AreasSection_list justify-content-center">
          {
            areas.map(item => (
              <li style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'logo.contentUrl'), { width: 1000, height: 1000, preserve: true })})` }} key={item._id} >
                <Link
                  name="homes"
                  className="AreasSection_item"
                  params={{
                    communityMarketAreaMetro: get(item, 'name'),
                    communityMarketArea: get(item, 'name'),
                  }}
                >
                  <hgroup className="d-flex flex-column align-items-center">
                    <h4 className="AreasSection_title">{get(item, 'name')}</h4>
                    <span className="AreasSection_subtitle mb-3 mb-lg-4">Available Homes</span>
                    <span className="AreasSection_btn" />
                  </hgroup>
                </Link>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

AreasSection.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  areas: true,
})(AreasSection);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/AreasSection.js